import { Pipe, PipeTransform } from '@angular/core';

import { toDecimalFormat } from '../utils/number';
import { getProperty } from '../utils/object';

@Pipe({
  name: 'sum',
})
export class SumPipe implements PipeTransform {
  /**
   * With a `format` (the number pipe's digitsInfo, e.g. `'1.2-2'`), each value is
   * rounded to its maximum decimals before it is added, so the total is the sum of
   * the values as the cells show them.
   */
  transform(
    list: any[],
    property: string,
    _timestamp: Date,
    format?: string
  ): number {
    if (!list?.length) {
      return 0;
    }

    const precision = getMaxFractionDigits(format);

    return list.reduce((acc, curr) => {
      const value = Number(getProperty(curr, property) ?? 0);
      const shown =
        precision == null
          ? value
          : Number(toDecimalFormat(value, precision) ?? value);

      return acc + shown;
    }, 0);
  }
}

function getMaxFractionDigits(format: string | undefined): number | null {
  const maxFractionDigits = format?.match(/-(\d+)$/)?.[1];

  return maxFractionDigits == null ? null : Number(maxFractionDigits);
}
